/**
 * AIPE Shoes — Sticky "Comprar" CTA on Mobile
 * Shows a fixed bottom bar when the main Add-to-Cart button
 * scrolls out of view on small screens.
 */
(function () {
  'use strict';

  if (window.innerWidth > 749) return; // Only on mobile

  var submitBtn = document.querySelector('.product-form__submit');
  if (!submitBtn) return;

  // Create the sticky bar
  var bar = document.createElement('div');
  bar.className = 'aipe-sticky-cta';
  bar.innerHTML =
    '<a href="/checkout" class="aipe-sticky-btn">🛒 Comprar Ahora</a>';
  document.body.appendChild(bar);

  // Watch visibility of the original button
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        if (entry.isIntersecting) {
          bar.classList.remove('aipe-visible');
        } else {
          bar.classList.add('aipe-visible');
        }
      },
      { threshold: 0.5 }
    );
    observer.observe(submitBtn);
  }
})();
